import Store from '../store'
let request = require('superagent');

let user = {
  auth: false,

  user: '',
  pass: '',
  syscode: '',
  config: { dumpsodalog: false }
}

export default user

/* 
  fields for config object:
  {
    dumpsodalog: bool
  }
*/ 
user.configure = (config) => {
  user.config.dumpsodalog = config.dumpsodalog || false
}

user.logout = () => {
  user.auth = false
  window.localStorage.user = null
  window.localStorage.pass = null
}

user.isAuthenticated = () => {
  return user.auth
}

user.getUserObject = () => {
  return {
    user: user.user,
    pass: user.pass,
    syscode: user.syscode
  }
}

user.hasStoredCreds = () => {
  return window.localStorage.user && window.localStorage.pass && window.localStorage.syscode
}

user.populateFromStorage = () => {
  user.user = window.localStorage.user
  user.pass = window.localStorage.pass
  user.syscode = window.localStorage.syscode
}

user.getUsername = () => {
  return user.user
}

user.getPassword = () => {
  return user.pass
}

user.getSystemCode = () => {
  return user.syscode
}

user.setUser = (username, password, systemcode) => {
  user.user = username
  user.pass = password
  user.syscode = systemcode
}

user.login = (onSuccess, onError) => {
  request
    .get('/umm/ummauth')
    .query({ dumpsodalog: user.dumpsodalog ? 'y' : 'n' })
    .query({ useSystemCode: user.syscode })
    .set('SODAUSER', user.user)
    .set('SODAKEY', user.pass)
    .set('content-type', 'application/json')
    .end((err, res) => {
      if (err || !res.ok) {
        user.auth = false
        window.localStorage.user = null
        window.localStorage.pass = null
        window.localStorage.syscode = null
        onError(err, res)
      } else {
        user.auth = true
        window.localStorage.user = user.user
        window.localStorage.pass = user.pass
        window.localStorage.syscode = user.syscode
        Store.init()
        onSuccess(err, res)
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/user.js